import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { mockData } from '../mockData';

const Header = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="dark-header">
      <Link to="/" className="dark-logo-link">
        <img 
          src={mockData.logo.url} 
          alt={mockData.logo.alt} 
          className="dark-logo"
        />
      </Link>
      
      <nav className="dark-nav">
        <Link 
          to="/" 
          className={`dark-nav-link ${isActive('/') ? 'active' : ''}`}
        >
          Home
        </Link>
        <Link 
          to="/privacy" 
          className={`dark-nav-link ${isActive('/privacy') ? 'active' : ''}`}
        >
          Privacy
        </Link>
        <Link 
          to="/terms" 
          className={`dark-nav-link ${isActive('/terms') ? 'active' : ''}`}
        >
          Terms
        </Link>
        <Link 
          to="/disclaimer" 
          className={`dark-nav-link ${isActive('/disclaimer') ? 'active' : ''}`}
        >
          Disclaimer
        </Link>
      </nav>
    </header>
  );
};

export default Header;
